import React from 'react';
export function HeroSection() {
  return <section className="relative w-full flex flex-col text-center px-4 py-8 sm:py-16 items-center justify-center pl-[20px] pr-[20px] pt-[20px] pb-[20px]" style={{
    background: 'linear-gradient(135deg, #0a0a0a 0%, #1a0f00 30%, #0d0700 60%, #0a0a0a 100%)'
  }} data-id="element-138">
      <div className="mb-4" data-id="element-139">
        <span className="text-[#F97316] text-xl sm:text-2xl font-black tracking-widest" data-id="element-140">
          🥊 EDULABS
        </span>
      </div>

      

      <h1 className="font-black text-white max-w-5xl sm:text-5xl md:text-7xl lg:text-8xl mb-[0px] text-[28px]" data-id="element-141">
        Todo tu año de boxeo
        <br data-id="element-142" />
        <span className="text-[#F97316]" data-id="element-143">resuelto.</span>
      </h1>

      <div className="w-full max-w-[280px] sm:max-w-[350px] md:max-w-[420px] mx-auto mb-4" style={{
      aspectRatio: '1/1'
    }} data-id="element-144">
        <img src="https://cdn.magicpatterns.com/uploads/k2YsmDJZftDntFdj12pEmR/Sin_titulo_(420_x_420_px)_(12).png" alt="EDULABS MegaPack Boxeo Listo — Combo Completo" className="w-full h-full object-contain" width={350} height={350} fetchPriority="high" data-id="element-145" />
      </div>

      <p className="text-[#F97316] sm:text-2xl font-bold max-w-3xl mb-[0px] text-[14px]" data-id="element-146">
        6 Tomos · 140+ Clases · 6 Bonos · Listo para usar.
      </p>

      <p className="text-white sm:text-lg max-w-2xl mb-[2px] pt-[8px] pb-[8px] text-[16px]" data-id="element-147">
        Tu año completo de boxeo listo: clases, técnica, potencia, defensa,
        táctica, guanteo y gestión. Sin improvisar. Sin cancelar. Sin quedarte
        sin ideas.
      </p>

      <div className="flex flex-nowrap mb-[10px] gap-[6px] items-center justify-center mx-auto" data-id="element-148">
        <span className="bg-black/50 border border-[#F97316]/40 text-white text-[10px] sm:text-sm font-semibold px-2 sm:px-3 py-1 sm:py-1.5 rounded-full whitespace-nowrap" data-id="element-149">
          📄 PDF digital
        </span>
        <span className="bg-black/50 border border-[#F97316]/40 text-white text-[10px] sm:text-sm font-semibold px-2 sm:px-3 py-1 sm:py-1.5 rounded-full whitespace-nowrap" data-id="element-150">
          ⚡ Acceso inmediato
        </span>
        <span className="bg-black/50 border border-[#F97316]/40 text-white text-[10px] sm:text-sm font-semibold px-2 sm:px-3 py-1 sm:py-1.5 rounded-full whitespace-nowrap" data-id="element-151">
          🥊 Todos los niveles
        </span>
      </div>

      <a href="#pricing" className="btn-green-pulse bg-[#F97316] font-black sm:text-2xl px-6 sm:px-10 py-4 sm:py-5 rounded-xl hover:bg-[#FB923C] transition-colors inline-block mb-5 w-full sm:w-auto max-w-sm text-[#FFFFFF] text-[16px]" data-id="element-152">
        💥 → QUIERO MI MEGAPACK AHORA
      </a>

      <p className="text-gray-300 text-xs sm:text-sm flex flex-wrap items-center justify-center gap-2 sm:gap-3" data-id="element-153">
        <span data-id="element-154">🛡️ Garantía 7 días sin preguntas</span>
        <span data-id="element-155">🔒 Pago 100% seguro</span>
        <span data-id="element-156">💳 Tarjeta · PayPal · Pago local disponible</span>
      </p>
    </section>;
}